import { PublicSettings } from "@/src/config/PublicSettings";

export type ISubMenu = {
    title: string;
    url: string;
    target?: string;
    rel?: string;
    isHeader?: boolean;
    submenu?: ISubMenu[];
};

export const footerFAQsSubmenus: ISubMenu[] = [
    {
        title: "What Does Pet Insurance Cover?",
        url: "/blog/why-pet-insurance/what-does-pet-insurance-cover"
    },
    {
        title: "Does Pet Insurance Cover Pre-Existing Conditions?",
        url: "/blog/why-pet-insurance/what-are-pre-existing-conditions-for-pet-insurance"
    },
    {
        title: "Does Pet Insurance Cover Spaying & Neutering?",
        url: "/blog/coverage/does-pet-insurance-cover-spaying-and-neutering"
    },
    {
        title: "How Pet Insurance Works?",
        url: "/blog/why-pet-insurance/how-does-pet-insurance-work"
    },
    {
        title: "How to Choose The Best Pet Insurance?",
        url: "/blog/how-pet-insurance-works/choose-the-best-pet-insurance"
    },
    {
        title: "Is Pet Insurance Worth It?",
        url: "/blog/why-pet-insurance/is-pet-insurance-worth-it"
    },
    {
        title: "Preventative Care Plans",
        url: "/blog/why-pet-insurance/pet-insurance-with-wellness-spot-preventive-care"
    },
    {
        title: "Should I Get Pet Insurance?",
        url: "/blog/why-pet-insurance/should-i-get-pet-insurance"
    }
];

export const footerLocationsSubmenus: ISubMenu[] = [
    {
        title: "California",
        url: "/locations/california"
    },
    {
        title: "Florida",
        url: "/locations/florida"
    },
    {
        title: "Illinois",
        url: "/locations/illinois"
    },
    {
        title: "New Jersey",
        url: "/locations/new-jersey"
    },
    {
        title: "New York",
        url: "/locations/new-york"
    },
    {
        title: "North Carolina",
        url: "/locations/north-carolina"
    },
    {
        title: "Pennsylvania",
        url: "/locations/pennsylvania"
    },
    {
        title: "Texas",
        url: "/locations/texas"
    },
    {
        title: "Washington",
        url: "/locations/washington"
    },
    {
        title: "All States",
        url: "/locations"
    }
];

export const footerAdviceSubmenus: ISubMenu[] = [
    {
        title: "Breed Tips",
        url: "/blog/breed-tips"
    },
    {
        title: "Cat Tips",
        url: "/blog/cat-tips"
    },
    {
        title: "Dog Tips",
        url: "/blog/dog-tips"
    },
    {
        title: "Kitten Tips",
        url: "/blog/kitten-tips"
    },
    {
        title: "Local Pet Insights",
        url: "/blog/local-insurance-insights"
    },
    {
        title: "Pet Lifestyle",
        url: "/blog/lifestyle"
    },
    {
        title: "Pet Safety",
        url: "/blog/pet-safety"
    },
    {
        title: "Puppy Tips",
        url: "/blog/puppy-tips"
    }
];

export const footerCompanySubmenus: ISubMenu[] = [
    {
        title: "About Us",
        url: "/about-us"
    },
    {
        title: "Careers",
        url: "https://www.linkedin.com/jobs/search?keywords=&location=United%20States&locationId=&geoId=103644278&f_TPR=&f_C=40836348&position=1&pageNum=0"
    },
    {
        title: "News",
        url: "/news"
    },
    {
        title: "Contact Us",
        url: "/contact"
    }
];

export const footerResourcesSubmenus: ISubMenu[] = [
    {
        title: "Employer Benefits",
        url: "/employers"
    },
    {
        title: "Agency Information",
        url: "/agency-info"
    },
    {
        title: "Sample Policy",
        url: "/sample-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    },
    {
        title: "Terms & Conditions",
        url: "/terms-conditions"
    },
    {
        title: "ADA Notice",
        url: "/ada-compliance-notice"
    },
    {
        title: "Member Center",
        url: PublicSettings.MEMBER_CENTER_URL_ROOT,
        target: "_self"
    },
    {
        title: "Claims Form",
        url: "/claims-form"
    },
    {
        title: "Help Center",
        url: "https://help.spotpet.com/en",
        target: "_blank",
        rel: "noreferrer"
    }
];
export const adviceSubmenus: ISubMenu[] = [
    {
        title: "Blogs",
        url: "/blog"
    },
    {
        title: "Dog Breeds",
        url: "/breeds/dog-breeds",
        submenu: [
            {
                title: "Cane Corso Cost",
                url: "/blog/breed-tips/how-much-does-a-cane-corso-cost"
            },
            {
                title: "Xoloitzcuintli Cost",
                url: "/blog/breed-tips/how-much-does-a-xoloitzcuintli-cost"
            },
            {
                title: "Belgian Malinois Cost",
                url: "/blog/breed-tips/how-much-does-a-belgian-malinois-cost"
            },
            {
                title: "Tibetan Mastiff Cost",
                url: "/blog/breed-tips/how-much-does-a-tibetan-mastiff-cost"
            },
            {
                title: "Caucasian Shepherd Cost",
                url: "/blog/breed-tips/how-much-does-a-caucasian-shepherd-cost"
            }
        ]
    },
    {
        title: "Cat Breeds",
        url: "/breeds/cat-breeds",
        submenu: [
            {
                title: "Female Cats Explained",
                url: "/blog/cat-tips/what-is-a-female-cat-called"
            },
            {
                title: "Manx Cat Cost",
                url: "/blog/breed-tips/how-much-does-a-manx-cat-cost"
            },
            {
                title: "British Shorthair Cost",
                url: "/blog/breed-tips/how-much-does-a-british-shorthair-cost"
            },
            {
                title: "Siamese Cat Cost",
                url: "/blog/breed-tips/how-much-does-a-siamese-cat-cost"
            },
            {
                title: "Can Cats Have Kiwi?",
                url: "/blog/cat-tips/can-cats-eat-kiwi"
            }
        ]
    },
    {
        title: "Pet Health Conditions",
        url: "/blog/health"
    },
    {
        title: "News",
        url: "/news"
    },
    {
        title: "FAQs",
        url: "/faqs"
    }
];
export const coverageSubmenus: ISubMenu[][] = [
    [
        {
            title: "What Does Pet Insurance Cover?",
            url: "/what-does-pet-insurance-cover"
        },
        {
            title: "Compare Pet Insurance Plans",
            url: "/compare-pet-insurance"
        }
    ],
    [
        {
            title: "Accidents",
            url: "/accident"
        },
        {
            title: "Dental",
            url: "/dental-coverage"
        },
        {
            title: "Emergency",
            url: "/emergency"
        },
        {
            title: "Illness",
            url: "/illness"
        },
        {
            title: "Wellness & Preventative",
            url: "/wellness"
        }
    ]
];
export const petSubmenus: ISubMenu[][] = [
    [
        {
            title: "Dog Insurance",
            url: "/dog-insurance"
        },
        {
            title: "Cat Insurance",
            url: "/cat-insurance"
        },
        {
            title: "Puppy Insurance",
            url: "/puppy-insurance"
        },
        {
            title: "Kitten Insurance",
            url: "/kitten-insurance"
        },
        {
            title: "Why pet insurance?",
            url: "/blog/why-pet-insurance"
        },
        {
            title: "Pet Insurance Reviews",
            url: "/pet-insurance-reviews"
        },
        {
            title: "Pet Insurance Cost",
            url: "/pet-insurance-cost"
        }
    ]
];

export const employerSubmenus: ISubMenu[] = [
    {
        title: "HR Professionals & Brokers",
        url: "/employers"
    }
];

export const ctaMapping = {
    // Special case for cart with id
    idMappings: {
        "cart-quote": "Cart CTA"
    },

    // URL path based mappings
    pathMappings: {
        "/quote": "Quote CTA",
        "quote.spotpet.com": "Quote CTA",
        "/member-center": "Member Center CTA",
        [new URL(PublicSettings.MEMBER_CENTER_URL_ROOT).host]: "Member Center CTA",
        "/employers": "Employers CTA",
        "/faqs": "FAQs CTA",
        "/spot-perks": "Perks CTA",
        "/what-does-pet-insurance-cover": "Coverage CTA",
        "/compare-pet-insurance": "Compare CTA",
        "/accident": "Accidents CTA",
        "/dental-coverage": "Dental CTA",
        "/emergency": "Emergency CTA",
        "/illness": "Illness CTA",
        "/wellness": "Wellness CTA",
        "/dog-insurance": "Dog CTA",
        "/cat-insurance": "Cat CTA",
        "/puppy-insurance": "Puppy CTA",
        "/kitten-insurance": "Kitten CTA",
        "/pet-insurance-reviews": "Reviews CTA",
        "/sample-policy": "Sample Policy CTA"
    },

    // URL pattern based mappings (only for special cases like phone numbers)
    patternMappings: [{ pattern: /^tel:/, name: "Call Us CTA" }]
};
